// angular
import { CommonModule, NgClass, NgOptimizedImage } from '@angular/common';
import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
// components
import { MarqueeTextComponent } from '../marquee-text/marquee-text.component';
import { TextSummarizerComponent } from '../text-summarizer/text-summarizer.component';
// interfaces & env
import { ICardTitle } from '@app/shared/interfaces/card-title.interface';
import { environment } from '@environments/environment';
// pipes
import { TranslateDataPipe } from '@app/shared/pipes/translate-data.pipe';
import { ImageSourcePipe } from '@app/shared/pipes/image-source.pipe';

@Component({
  selector: 'pwj-card-title',
  standalone: true,
  imports: [
    CommonModule,
    NgOptimizedImage,
    NgClass,
    MarqueeTextComponent,
    TextSummarizerComponent,
    TranslateDataPipe,
    ImageSourcePipe,
    RouterLink,
  ],
  templateUrl: './card-title.component.html',
  styleUrl: './card-title.component.scss',
})
export class CardTitleComponent {
  public baseUrl: string = environment.baseUrl.base;

  // inputs
  cardTitleData = input.required<ICardTitle>();
}
